export const processSelectedMenu: any = (rawData: any) => {
  const data = rawData.data;
  let meals = data.meals;

  const included = rawData.included;
  const { dishes, categories } = included;

  const sections = ["breakfast", "lunch", "dinner", "snack"];

  let finalData = [];

  const mergedMeals = meals.reduce((acc: any, meal: any) => {
    const existingMeal = acc.find(
      (m: any) => m.dishId === meal.dishId && m.name === meal.name
    );

    if (existingMeal) {
      // Meal with same dishId and name already exists, add classifications to it
      if (existingMeal) {
        // Meal with same dishId and name already exists, add classifications to it
        const uniqueClassifications = new Set([
          ...existingMeal.classifications,
          ...meal.classifications,
        ]);
        existingMeal.classifications = Array.from(uniqueClassifications);
      }
    } else {
      // This is a new meal, add it to the array
      acc.push(meal);
    }

    return acc;
  }, []);

  for (const sectionItem of sections) {
    let mealItems = [];

    for (const meal of mergedMeals) {
      const mealClassifications = meal.classifications;
      const dish = dishes.find((obj: any) => obj.id === meal.dishId);
      const category = categories.find(
        (cat: any) => cat.categoryId === dish.categoryId
      );

      const filteredArr = mealClassifications.filter((str: string) =>
        str.toLowerCase().includes(sectionItem)
      );

      for (const item of filteredArr) {
        const mealItem = {
          ...meal,
          dishObj: dish,
          currentClassification: item,
          category: category,
        };
        mealItems.push(mealItem);
      }

      // if default in mealClassification
      const isDefaultClassification = mealClassifications.some((item: any) =>
        item.toLowerCase().includes("default")
      );

      if (isDefaultClassification) {
        if (sectionItem === dish.classification.toLowerCase()) {
          const mealItem = {
            ...meal,
            dishObj: dish,
            currentClassification: "default",
            category: category,
          };
          mealItems.push(mealItem);
        }
      }
    }

    // sort by category name
    mealItems.sort((a: any, b: any) => {
      // Check if a's category title is empty
      if (!a?.category?.title) return 1;

      // Check if b's category title is empty
      if (!b?.category?.title) return -1;

      // Compare category titles
      if (a.category.title < b.category.title) return -1;
      if (a.category.title > b.category.title) return 1;

      return 0;
    });

    const processedData = {
      classification: sectionItem,
      meals: mealItems,
    };

    //append to final data
    finalData.push(processedData);
  }

  return finalData;
};
